import { fromJS } from 'immutable'
import {
  PROJECT_INFORMATION_CREATE_REQUEST,
  PROJECT_INFORMATION_CREATE_SUCCESS,
  PROJECT_INFORMATION_CREATE_FAILURE,
  PROJECT_INFORMATION_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case PROJECT_INFORMATION_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case PROJECT_INFORMATION_CREATE_SUCCESS:
      return state
        .set('createdProject', fromJS(action.payload.createdProject))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case PROJECT_INFORMATION_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('createdProject', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
    case PROJECT_INFORMATION_CREATE_RESET:
      return state
        .delete('createdProject')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project-information/project-information-create-reducer.js